import { forwardRef, type Ref, type SVGProps } from "react";
const IconCreditCardFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M22 14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm-5.5 5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z"
      clipRule="evenodd"
    />
    <path d="M28 16a2 2 0 0 1-2 2h-1v-2.5a2.5 2.5 0 0 0-2.5-2.5H8v-3h20z" />
    <path d="M26 5a2 2 0 0 1 2 2v1H8V7a2 2 0 0 1 2-2z" />
  </svg>
);
const ForwardRef = forwardRef(IconCreditCardFilledSVG);
ForwardRef.displayName = "IconCreditCardFilled";
export { ForwardRef as IconCreditCardFilled };
